module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-kanto-3-014cb19f80ca6101615391a5143aacb9.png";